import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthApiService } from 'src/app/core/services/auth-api.service';
import { httpErrorMsgs } from 'src/app/core/utils/htp-error';

@Component({
  selector: 'app-join',
  templateUrl: 'join.component.html'
})
export class JoinComponent implements OnInit {
  public form: FormGroup;
  public error: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthApiService,
    private fb: FormBuilder,
  ) { }

  public ngOnInit(): void {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]],
      invite_code: [this.route.snapshot.params['code'], [Validators.required]],
    });

    this.authService.lastLogin().then(username => {
      if (username) {
        this.form.patchValue({ email: atob(username) });
      }
    });
  }

  public onSubmit() {
    this.error = null;

    const value = this.form.value;
    this.authService.join(value).subscribe(() => {
      this.authService.login(value.email, value.password).subscribe(ok => {
        this.router.navigateByUrl('/organizations');
      }, err => {
        this.loginError(err);
      });
    }, err => {
      this.loginError(err);
    });
  }

  public loginError(error: Error | string) {
    if (typeof (error) === 'string') {
      this.error = <string>error;
      return;
    }

    const htpErros = httpErrorMsgs(<Error>error, {
      email: 'E-mail',
      password: 'Senha',
      invite_code: 'Código de Convite'
    });

    this.error = '';
    htpErros.forEach(err => {
      const msg = err.title ? `${err.title}: ${err.msg}` : err.msg;
      this.error += msg + '\n';
    });
  }
}
